import { apiCall } from './gqlClient';

const GETPROVIDERINVITATIONFLOWS_QUERY = `
  query getProviderInvitationFlows {
    getProviderInvitationFlows
  }`;

export const getProviderInvitationFlowsApiCall = async () => apiCall({ query: GETPROVIDERINVITATIONFLOWS_QUERY, variables: {}});

const GETPROVIDERCUSTOMERSINVITATIONFLOWS_QUERY = `
  query getProviderCustomersInvitationFlows {
    getProviderCustomersInvitationFlows
  }`;

export const getProviderCustomersInvitationFlowsApiCall = async () => apiCall({ query: GETPROVIDERCUSTOMERSINVITATIONFLOWS_QUERY, variables: {}});

const UPDATECUSTOMERFLOWOWNERSTATUS_QUERY = `
  mutation updateCustomerFlowOwnerStatus($customerFlowId: String!, $status: String!, $rejectionType: String, $rejectionReason: String) {
    updateCustomerFlowOwnerStatus(customerFlowId: $customerFlowId, status: $status, rejectionType: $rejectionType, rejectionReason: $rejectionReason)
  }`;

export const updateCustomerFlowOwnerStatusApiCall = async ({customerFlowId, status, rejectionType, rejectionReason}, ) => apiCall({ query: UPDATECUSTOMERFLOWOWNERSTATUS_QUERY, variables: {customerFlowId, status, rejectionType, rejectionReason}});

const CREATEINVITATIONFLOW_QUERY = `
  mutation createInvitationFlow($request: JSON!) {
    createInvitationFlow(request: $request)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const createInvitationFlowApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEINVITATIONFLOW_QUERY, variables: {request}, fragments });

const UPDATEINVITATIONFLOW_QUERY = `
  mutation updateInvitationFlow($request: JSON!) {
    updateInvitationFlow(request: $request)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const updateInvitationFlowApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEINVITATIONFLOW_QUERY, variables: {request}, fragments });

const SETDEFAULTINVITATIONFLOW_QUERY = `
  mutation setDefaultInvitationFlow($id: String!) {
    setDefaultInvitationFlow(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const setDefaultInvitationFlowApiCall = async ({id}, fragments = null) => apiCall({ query: SETDEFAULTINVITATIONFLOW_QUERY, variables: {id}, fragments });

const REMOVEDEFAULTINVITATIONFLOW_QUERY = `
  mutation removeDefaultInvitationFlow {
    removeDefaultInvitationFlow
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const removeDefaultInvitationFlowApiCall = async (fragments = null) => apiCall({ query: REMOVEDEFAULTINVITATIONFLOW_QUERY, variables: {}, fragments });

const ARCHIVEINVITATIONFLOW_QUERY = `
  mutation archiveInvitationFlow($id: String!) {
    archiveInvitationFlow(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveInvitationFlowApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEINVITATIONFLOW_QUERY, variables: {id}, fragments });

const GETFLOWSIGNATUREUPLOADURL_QUERY = `
  mutation getFlowSignatureUploadUrl($request: FlowSignatureUploadUrlInput!) {
    getFlowSignatureUploadUrl(request: $request)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getFlowSignatureUploadUrlApiCall = async ({request}, fragments = null) => apiCall({ query: GETFLOWSIGNATUREUPLOADURL_QUERY, variables: {request}, fragments });

const UPDATECUSTOMERDATAFROMINVITATIONFLOW_QUERY = `
  mutation updateCustomerDataFromInvitationFlow($request: CustomerDataFromFlowInput!) {
    updateCustomerDataFromInvitationFlow(request: $request)
    {
      id
			copyId
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const updateCustomerDataFromInvitationFlowApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATECUSTOMERDATAFROMINVITATIONFLOW_QUERY, variables: {request}, fragments });

const SENDINVITATIONFLOW_QUERY = `
  mutation sendInvitationFlow($userId: Int!, $flowId: String!) {
    sendInvitationFlow(userId: $userId, flowId: $flowId)
  }`;

export const sendInvitationFlowApiCall = async ({userId, flowId}, ) => apiCall({ query: SENDINVITATIONFLOW_QUERY, variables: {userId, flowId}});
